<div class="block">
    <div class="txt-404">404</div>
    <div class="txt">Page Not Found</div>
</div>
